// removed by extract-text-webpack-plugin
module.exports = {"header":"c-OrderHeader__header","content":"c-OrderHeader__content","sticky":"c-OrderHeader__sticky"};